import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { JobImageService } from './job-image.service';
import { ConfigurationService } from './configuration.service';
import { JobLocation, JobsResponse, JobSummary } from '@interfaces/jobs.interface';
import { JobDetails } from '@interfaces/job-details.interface';

@Injectable({
  providedIn: 'root'
})
export class JobService {
  private readonly http = inject(HttpClient);
  private readonly jobImageService = inject(JobImageService);
  private readonly configuration = inject(ConfigurationService);

  public jobs!: JobSummary[];
  public departments!: string[];
  public locations!: JobLocation[];

  public getJobs(): Promise<JobSummary[]> {
    if (this.jobs) {
      return new Promise<JobSummary[]>(resolve => { resolve(this.jobs); })
    }

    const configuration = this.configuration.config();
    const jobsUrl = `${configuration?.api.baseUrl}${configuration?.api.jobsUrl}`;

    return firstValueFrom(this.http.get<JobsResponse>(jobsUrl)).then((response) => {
      this.jobs = response.content;
      this.departments = [];
      this.jobs.forEach((job) => {
        if (this.departments.indexOf(job.function.label) === -1) {
          this.departments.push(job.function.label)
        }
      });

      this.locations = [];
      this.jobs.forEach((job) => {
        if (this.locations.findIndex(loc => loc.city === job.location.city) === -1) {
          this.locations.push(job.location)
        }
      });

      //generate job images
      this.jobs.forEach((job) => {
        job.jobImage = this.jobImageService.getJobImage();
      });

      return this.jobs;
    });
  }

  public async getJobById(jobId: string): Promise<JobSummary | undefined> {
    const jobs = await this.getJobs();
    return jobs.find(x => x.id === jobId);
  }

  public async getJobDetails(jobId: string): Promise<JobDetails | undefined> {
    const configuration = this.configuration.config();
    const jobDetailsUrl = `${configuration?.api.baseUrl}${configuration?.api.jobDetailsUrl}${jobId}`;

    try {
      return firstValueFrom(this.http.get<JobDetails>(jobDetailsUrl)).then(response => {
        return response;
      });
      
    } catch {
      return undefined;
    }
  }
}
